import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { Button, CircularProgress, Typography } from '@mui/material'
import withPrimaryColor from '@v4/components/common/withPrimaryColor'
import { useEditableButton } from './EditableButton.hooks'

const EditableButton = props => {
	const [
		{
			classes,
			cx,
			className,
			html,
			loading,
			elementRef,
			contentEditable,
			activeEditor,
			displayEmpty,
			startIconClassName,
			placeholder,
			...rest
		},
		{ handleClick },
	] = useEditableButton(props)

	return html || displayEmpty ? (
		<Button
			key={contentEditable ? 'editable' : 'not-editable'}
			classes={{
				startIcon: startIconClassName,
				outlined: classes.outlined,
			}}
			{...rest}
			className={cx(classes.root, className, 'button')}
			onClick={handleClick}
		>
			<Typography className={cx(classes.label, 'button-label')} variant="button" color="inherit">
				<div
					ref={elementRef}
					className={cx(contentEditable && classes.editable)}
					data-placeholder={placeholder}
					{...(activeEditor && contentEditable
						? { tabIndex: -1 }
						: { dangerouslySetInnerHTML: { __html: html } })}
				/>
			</Typography>
			{loading && <CircularProgress size={24} className={cx(classes.progress, 'button-progress')} />}
		</Button>
	) : null
}

EditableButton.propTypes = {
	className: PropTypes.string,
	startIconClassName: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		label: PropTypes.string,
	}),
	children: PropTypes.node,
	onClick: PropTypes.func,
	component: PropTypes.elementType,
	loading: PropTypes.bool,
	onChange: PropTypes.func,
	onDelete: PropTypes.func,
	editable: PropTypes.bool,
	displayEmpty: PropTypes.bool,
	onLabelFocus: PropTypes.func,
	rounded: PropTypes.bool,
	variant: PropTypes.oneOf(['filled', 'outlined']),
	color: PropTypes.oneOf(['white', 'primary', 'secondary', 'text']),
	autoFocus: PropTypes.bool,
}

export default memo(withPrimaryColor(EditableButton))
